// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IpfilterTrafficType } from './IpfilterTrafficType';
import {
  IpfilterTrafficTypeFromJSON,
  IpfilterTrafficTypeFromJSONTyped,
  IpfilterTrafficTypeToJSON,
  IpfilterTrafficTypeToJSONTyped,
} from './IpfilterTrafficType';

/**
 *
 * @export
 * @interface IpfilterIngressTrafficType
 */
export interface IpfilterIngressTrafficType {
  /**
   *
   * @type {string}
   * @memberof IpfilterIngressTrafficType
   */
  dbid?: string;
  /**
   *
   * @type {string}
   * @memberof IpfilterIngressTrafficType
   */
  statusActiveTrafficType?: string;
  /**
   *
   * @type {string}
   * @memberof IpfilterIngressTrafficType
   */
  tenantId?: string;
  /**
   *
   * @type {IpfilterTrafficType}
   * @memberof IpfilterIngressTrafficType
   */
  trafficType?: IpfilterTrafficType;
}

/**
 * Check if a given object implements the IpfilterIngressTrafficType interface.
 */
export function instanceOfIpfilterIngressTrafficType(
  value: object,
): value is IpfilterIngressTrafficType {
  return true;
}

export function IpfilterIngressTrafficTypeFromJSON(
  json: any,
): IpfilterIngressTrafficType {
  return IpfilterIngressTrafficTypeFromJSONTyped(json, false);
}

export function IpfilterIngressTrafficTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IpfilterIngressTrafficType {
  if (json == null) {
    return json;
  }
  return {
    dbid: json['dbid'] == null ? undefined : json['dbid'],
    statusActiveTrafficType:
      json['statusActiveTrafficType'] == null
        ? undefined
        : json['statusActiveTrafficType'],
    tenantId: json['tenantId'] == null ? undefined : json['tenantId'],
    trafficType:
      json['trafficType'] == null
        ? undefined
        : IpfilterTrafficTypeFromJSON(json['trafficType']),
  };
}

export function IpfilterIngressTrafficTypeToJSON(
  json: any,
): IpfilterIngressTrafficType {
  return IpfilterIngressTrafficTypeToJSONTyped(json, false);
}

export function IpfilterIngressTrafficTypeToJSONTyped(
  value?: IpfilterIngressTrafficType | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    dbid: value['dbid'],
    statusActiveTrafficType: value['statusActiveTrafficType'],
    tenantId: value['tenantId'],
    trafficType: IpfilterTrafficTypeToJSON(value['trafficType']),
  };
}
